export default __webpack_public_path__ + "static/media/REYNA.07a3128a.png";